<template>
  <div class="d-flex flex-column" style="height: 100%; background: #fff">
    <!-- Sidebar Header -->
    <div
      class="d-flex align-center px-4"
      style="height: 64px; background: #fff; border-bottom: 1px solid #e0e0e0; flex-shrink: 0"
    >
      <span class="text-h6 font-weight-bold" style="color: #111; letter-spacing: 0.3px">Messenger</span>
      <v-spacer />
      <v-btn icon @click="$emit('openNewChat')">
        <v-icon color="grey darken-1">mdi-message-plus-outline</v-icon>
      </v-btn>
    </div>

    <!-- Search Bar -->
    <div class="px-3 py-2" style="background: #fff; flex-shrink: 0">
      <v-text-field
        v-model="searchKeyword"
        outlined
        dense
        hide-details
        placeholder="Search chats…"
        prepend-inner-icon="mdi-magnify"
        clearable
        background-color="#f5f5f5"
        style="border-radius: 24px"
        @click:clear="searchKeyword = ''"
      ></v-text-field>
    </div>

    <!-- Loading bar -->
    <v-progress-linear
      v-if="loading"
      indeterminate
      color="success"
      height="2"
    ></v-progress-linear>

    <!-- Chat List -->
    <div class="flex-grow-1 overflow-y-auto">
      <template v-if="filteredChats.length > 0">
        <ChatListItem
          v-for="chat in filteredChats"
          :key="chat.id"
          :chat="chat"
          :selected="selectedChatId === chat.id"
          @click="handleSelectChat(chat)"
        />
      </template>

      <!-- Empty State -->
      <div
        v-else-if="!loading"
        class="d-flex flex-column align-center justify-center pa-8"
        style="height: 60%"
      >
        <v-icon size="72" color="grey lighten-2">mdi-chat-outline</v-icon>
        <p class="text-subtitle-1 grey--text mt-3 mb-4">No chats found</p>
        <v-btn color="success" depressed rounded @click="$emit('openNewChat')">
          <v-icon left small>mdi-plus</v-icon>
          Start New Chat
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import ChatListItem from './ChatListItem.vue';

export default {
  name: 'ChatList',

  components: { ChatListItem },

  data() {
    return { searchKeyword: '' };
  },

  computed: {
    ...mapState('chat', ['loading', 'selectedChatId']),
    ...mapGetters('chat', ['sortedChats']),

    filteredChats() {
      if (!this.searchKeyword) return this.sortedChats;
      const kw = this.searchKeyword.toLowerCase();
      return this.sortedChats.filter((chat) => {
        if (chat.is_group) return chat.name?.toLowerCase().includes(kw);
        const other = chat.users?.find(u => u.id !== this.user.id);
        if (other) {
          return `${other.first_name} ${other.last_name}`.toLowerCase().includes(kw);
        }
        return false;
      });
    }
  },

  methods: {
    handleSelectChat(chat) {
      this.$emit('selectChat', chat);
    }
  }
};
</script>

<style scoped>
.overflow-y-auto::-webkit-scrollbar { width: 4px; }
.overflow-y-auto::-webkit-scrollbar-track { background: transparent; }
.overflow-y-auto::-webkit-scrollbar-thumb { background: #ddd; border-radius: 2px; }
.overflow-y-auto::-webkit-scrollbar-thumb:hover { background: #bbb; }
</style>
